import { render, staticRenderFns } from "./FullscreenLayout.vue?vue&type=template&id=a7cf38d6&scoped=true"
import script from "./FullscreenLayout.vue?vue&type=script&lang=js"
export * from "./FullscreenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf38d6",
  null
  
)

export default component.exports